import { createSelector } from 'reselect';
import { PushSubscriptionState } from './types';
import { reduxKey } from './constants';
function getSlice(state) {
    return state[reduxKey] || {
        pushSubscriptionState: PushSubscriptionState.LOADING
    };
}
export const getPushSubscriptionState = createSelector(getSlice, (slice)=>slice.pushSubscriptionState);

//# sourceMappingURL=selectors.js.map